import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import './AdminLogin.css';
import { API_URL } from '../config';

function AdminLogin({ onAdminLogin, onBackToLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Make sure we're sending to the correct endpoint
      const response = await axios.post(`${API_URL}/api/admin/login`, {
        username: username.trim(),
        password: password.trim()
      });

      const { token } = response.data;
      
      // Store admin-specific token
      localStorage.setItem('adminToken', token);
      localStorage.setItem('isSystemAdmin', 'true');
      
      // Configure axios for future requests
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      
      // Update admin state
      onAdminLogin({ isSystemAdmin: true });
      
      // Navigate to admin panel
      navigate('/admin/panel', { replace: true });
    } catch (err) {
      console.error('Login error:', err);
      toast.error(err.response?.data?.error || 'Login failed. Please check your credentials.');
    }
  };

  return (
    <div className="admin-login-container">
      <h2>System Admin Login</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
            required
          />
        </div>
        <div className="form-group">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
          />
        </div>
        <button type="submit">Login as Admin</button>
      </form>
      <button 
        className="back-to-login" 
        onClick={onBackToLogin}
      >
        ← Back to Business Login
      </button>
    </div>
  );
}

export default AdminLogin; 